import { DataBean } from "../DataBean";

export class BoardColumnStatuses extends DataBean {

  public async getBoardColumnStatusesRender(properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getBoardColumnStatusesRender_java.util.Map",
      [properties]
    );
  }

  public async getBoardColumnStatusesCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getBoardColumnStatusesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteBoardColumnStatuses(idboardcolumnstatuses: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteBoardColumnStatuses_Number",
      [idboardcolumnstatuses]
    );
  }

  public async updateBoardColumnStatuses(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.BoardColumnStatuses_updateBoardColumnStatuses_com.advantage.processflow.bean.BoardColumnStatuses",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.BoardColumnStatuses",
        },
      ]
    );
  }
}
